// TUT-450 — os relatórios: modelos prontos, fontes, salvos e execução.
import { demoApi } from "../demo-data";
import type {
  ExportReportInput,
  ReportPreset,
  SavedReport,
  SaveReportInput,
  ReportQuery,
  ReportResult,
  ReportSourceDef,
} from "../types";
import { request, requestBlob } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDosRelatorios = {
  // Relatórios (TUT-128 fase 2).
  reportPresets(): Promise<{ items: ReportPreset[] }> {
    if (useDemoApi) return demoApi.reportPresets();
    return request<{ items: ReportPreset[] }>("/reports/presets");
  },
  reportSources(): Promise<{ items: ReportSourceDef[] }> {
    if (useDemoApi) return demoApi.reportSources();
    return request<{ items: ReportSourceDef[] }>("/reports/sources");
  },
  // TUT-128 fase 4b: relatórios salvos.
  savedReports(): Promise<{ items: SavedReport[] }> {
    if (useDemoApi) return demoApi.savedReports();
    return request<{ items: SavedReport[] }>("/reports/saved");
  },
  saveReport(input: SaveReportInput): Promise<SavedReport> {
    if (useDemoApi) return demoApi.saveReport(input);
    return request<SavedReport>("/reports/saved", {
      method: "POST",
      body: JSON.stringify(input),
    });
  },
  deleteSavedReport(id: string): Promise<void> {
    if (useDemoApi) return demoApi.deleteSavedReport(id);
    return request<void>(`/reports/saved/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
  },
  runReport(query: ReportQuery): Promise<ReportResult> {
    if (useDemoApi) return demoApi.runReport(query);
    return request<ReportResult>("/reports/run", {
      method: "POST",
      body: JSON.stringify(query),
    });
  },
  /** TUT-490a — a planilha XLSX, gerada no servidor (`exceljs`, em fluxo). */
  exportReportXlsx(input: ExportReportInput): Promise<Blob> {
    if (useDemoApi) return demoApi.exportReportXlsx(input);
    return requestBlob("/reports/export", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    });
  },
};
